import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

export const defaultApplicationTitle = 'Buildium';

@Injectable({
    providedIn: 'root'
})
export class PageTitleService {
    appTitle = defaultApplicationTitle;
    constructor(
        private titleService: Title
    ) { }

    setTitle(pageTitle: string) {
        let htmlDocTitle = this.appTitle;

        if (pageTitle) {
            htmlDocTitle = pageTitle;
        }
        this.titleService.setTitle(htmlDocTitle);
    }
}
